/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import mbpLogger from 'mbp-logger';
import withWidth from '@material-ui/core/withWidth';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

// API Calls
import getDeliveryCalendarByProduct from '../../../../../../../../../apis/product-apis/getDeliveryCalendarByProduct';

// Checkout UI
import DeliveryCalendarHeader from '../DeliveryCalendarHeader/DeliveryCalendarHeader';
import CalendarView from '../CalendarView/CalendarView';
import MonthDatedCalendarView from '../CalendarView/MonthDatedCalendarView';
import WeekDatedCalendarView from '../CalendarView/WeekDatedCalendarView';
import ArrivalDetails from '../ArrivalDetails/ArrivalDetails';
import * as CalendarUtility from '../CalendarView/helpers/calendarUtility';
import ErrorMessage from '../../../ErrorMessage/ErrorMessage';

import { withAuth } from '../../../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';

// Member
import {
    getShopRunnerToken,
    getIsPassportUserLoggedIn,
} from '../../../../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';

// Checkout
import * as commonSelectors from '../../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import {
    getPassportSubscriptionStatus,
} from '../../../../../../../../../state/ducks/MfeCheckout/ducks/Cart/Cart-Selectors';
import cartServiceClient  from '../../../../../../../../../apis/cart-service-apis';
import CloseCalendarConsent from '../CloseCalendarConsent/CloseCalendarConsent';

const styles = (theme) => ({
    MonthHeader: {
        margin: '6px 0px',
    },
    WeekHeader: {
        margin: '3px 0px',
    },
    dayOfTheWeek: {
        margin: '3px 0px',
    },
    holidayBtnStyle: {
        backgroundColor: theme.palette.background?.paper,
    },
    selectedUpChargeBtn: {
        backgroundColor: `${(theme.palette.selectedDeliveryDay || theme.palette.primary?.main || '#2f2f2f')}!important`,
        '& button': {
            padding: '5px 0px 0px 0px',
            color: theme.palette.chargesDeliveryDay || '#56b4e9',
            borderRadius: '0',
            width: '100%',
            fontSize: '1em',
            display: 'block',
            minWidth: 'initial',
            height: '53px',
            maxHeight: '53px',
        },
    },
    selectedFreeBtn: {
        backgroundColor: `${(theme.palette.selectedDeliveryDay || theme.palette.primary?.main || '#2f2f2f')}!important`,
        '& button': {
            padding: '5px 0px 0px 0px !important',
            color: theme.palette.chargesDeliveryDay || '#56b4e9',
            borderRadius: '0',
            width: '100%',
            fontSize: '1em',
            display: 'block',
            minWidth: 'initial',
            height: '53px',
            maxHeight: '53px',
        },
    },
    selectedBtn: {
        backgroundColor: `${(theme.palette.selectedDeliveryDay || theme.palette.primary?.main || '#2f2f2f')}!important`,
        '& button': {
            color: theme.palette.chargesDeliveryDay || '#56b4e9 !important',
            borderRadius: '0',
            width: '100%',
            fontSize: '1em',
            display: 'block',
            padding: '0px 0px 16px 0px',
            minWidth: 'initial',
            height: '53px',
            maxHeight: '53px',
        },
    },
    unselectedBtn: {
        '& button': {
            borderRadius: '0',
            color: theme.palette.unSelectedDeliveryDay || '#516a85',
            width: '100%',
            fontSize: '1em',
            display: 'block',
            padding: '0px 0px 15px 0px',
            minWidth: 'initial',
            height: '53px',
            maxHeight: '53px',
        },
    },
    disabledBtn: {
        borderRadius: '0',
        width: '100%',
        fontSize: '1em',
        display: 'block',
        padding: '0px 0px 16px 0px',
        minWidth: 'initial',
        color: `${theme.palette.disabledDeliveryDay || '#d1d1c0'} !important`,
        maxHeight: '53px',
        height: '53px',
    },
    upChargeBtn: {
        '& button': {
            width: '100%',
            color: theme.palette.chargesDeliveryDay || '#a94',
            fontSize: '1em',
            display: 'block',
            padding: '0',
            minWidth: 'initial',
            height: '53px',
            maxHeight: '53px',
        },
    },
    freeDelivery: {
        '& button': {
            width: '100%',
            color: theme.palette.chargesDeliveryDay || '#516a85',
            fontSize: '1em',
            display: 'block',
            padding: '0',
            minWidth: 'initial',
            height: '53px',
            maxHeight: '53px',
        },
    },
    pricePerDay: {
        fontSize: '12px',
        color: theme.palette.chargesDeliveryDay || '#000',
        display: 'block',
        fontWeight: '700',
    },
    pricePerDaySelected: {
        fontSize: '12px',
        color: theme.palette.chargesDeliveryDay || '#fff',
        display: 'block',
        fontWeight: '700',
    },
    chargeTextStyle: {
        textTransform: 'none',
    },
    legendShipAndUpCharge: {
        width: '15px',
        height: '15px',
        display: 'block',
        borderRadius: '50%',
        backgroundColor: theme.palette.chargesDeliveryDay || '#a94',
        padding: '6px',
        border: 'solid 1px #968e8e',
    },
    legendStandardShipingCharge: {
        width: '15px',
        height: '15px',
        display: 'block',
        borderRadius: '50%',
        backgroundColor: theme.palette.chargesDeliveryDay || '#56b4e9',
        padding: '3px',
        border: 'solid 1px #968e8e',
    },
    legendUnavailable: {
        width: '15px',
        height: '15px',
        display: 'block',
        borderRadius: '50%',
        backgroundColor: '#d1d1c0',
        padding: '3px',
        border: 'solid 1px #968e8e',
    },
    legendHoliday: {
        width: '15px',
        height: '15px',
        display: 'block',
        borderRadius: '50%',
        backgroundColor: '#FFF',
        border: 'solid 1px #968e8e',
        padding: '0 0 0 2px',
        textIndent: '1px',
        lineHeight: '20px',
    },
    calendarLoader: {
        width: '100%',
        textAlign: 'center',
        padding: '100px 0px',
    },
    marginTopToFixHeader: {
        marginTop: '50px',
        '&.marginTopRaised': {
            marginTop: '0',
        },
    },
    legendTextStyle: {
        fontSize: '12px',
    },
    gridStyle: {
        padding: '0px',
        width: '100%',
        '& li': {
            paddingTop: '0px',
        },
    },
    gridStylePadding: {
        padding: '0 10px',
        minHeight: '40vh',
    },
    gridStyleMargin: {
        marginBottom: '16px',
    },
    relative: {
        position: 'relative',
        minHeight: '50vh',
    },
    monthlyWeeklyText: {
        fontSize: '1em',
    },
    deliveryHeaderCaption: {
        fontSize: '17px',
        margin: '9px',
    },
    [theme.breakpoints.only('xs')]: {
        legendTextStyle: {
            padding: '5px',
        },
    },
    [theme.breakpoints?.up('sm')]: {
        deliveryCalenderContainer: {
            padding: '8px',
        },
        gridStylePadding: {
            padding: '10px',
        },
        selectedUpChargeBtn: {
            '& button': {
                padding: '0px !important',
            },
        },
        unselectedBtn: {
            '&.button-enabled:hover': {
                backgroundColor: (theme.palette.selectedDeliveryDay || theme.palette.primary?.[100] || '#aeaeae'),
                '& button': {
                    color: (theme.palette.unSelectedDeliveryDay || theme.palette.common?.white || '#fff'),
                },
            },
        },
        upChargeBtn: {
            '&:hover': {
                backgroundColor: (theme.palette.chargesDeliveryDay || theme.palette.primary?.[100] || '#a94'),
                '& div': {
                    color: (theme.palette.common?.white || '#fff'),
                },
            },
        },
        arrivalDetailsContainer: {
            padding: '10px 0px',
            position: 'relative',
            marginBottom: '11px',
        },
        gridStyleMargin: {
            margin: '15px 5px 45px 5px',
            border: `1px solid ${(theme.palette.primary?.[200] || '#d5d5d5')}`,
            '&>p': {
                backgroundColor: (theme.palette.primary?.[200] || '#d5d5d5'),
                textAlign: 'center',
                padding: '6px',
                fontSize: '1em',
                fontWeight: 600,
                textTransform: 'none',
            },
        },
        legendTextStyle: {
            padding: '0px 10px',
            '& p': {
                fontSize: '1em',
            },
        },
    },
    deliveryCalendarDialogRoot: {
        top: '5px !important',
        bottom: 'auto !important',
    },
    deliveryCalendarDialogPaper: {
        maxWidth: '900px',
        marginTop: '0px',
        borderRadius: '0px',
        maxHeight: 'calc(100vh - 25px)',
        width: '100%',
    },
    prevButton: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '1em',
        fontWeight: '500',
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        textTransform: 'none',
        '&:hover, &:focus, &:active': {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
            textDecoration: 'underline',
        },
    },
});

class DeliveryCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: '',
            endDate: '',
            selectedDateRange: [],
            selectedDeliveryDate: {},
            calendarResponse: {},
            forceExactDay: false,
            calendarDisplayData: {},
            showLoader: false,
            selectedHoliday: {},
            shipHolidayDetails: {},
            selectedDateAnHoliday: false,
            holidaySelected: 'Select a holiday',
            monthDatedData: [],
            weekDatedData: [],
            activeMonth: '',
            activeWeek: '',
            errorMessage: null,
        };
        this.deliveryDate = [];
        this.selectedDate = '';
        this.savedDateHoliday = '';
        this.selectedDateType = '';
        this.holidayDateCollection = [];
    }

    componentDidMount = () => {
        this.initCalendar();
    }

    handleDeliveryResponse(response, detailsForDate) {
        if (response.data) {
            if (response.data.response.deliveryIndicator === 'MO') {
                this.handleDeliveryMonthResponse(response);
            } else if (response.data.response.deliveryIndicator === 'WO') {
                this.handleDeliveryWeekResponse(response);
            } else {
                this.handleDeliveryDateResponse(response, detailsForDate);
            }
        } else {
            const err = new Error('Response Error');
            err.response = {
                data: {
                    response: 'Error',
                    detailedError: {
                        errorKey: 'No Date are available',
                        errorMessage: 'No Date are available',
                        detailedErrorMessage: 'No Date are available',
                        validationErrors: [],
                    },
                },
            };

            throw err;
        }
    }

    onChangeForceExactDay = (event) => {
        const isChecked = event.target.checked;
        const { selectedDeliveryDate, calendarResponse } = this.state;
        let { selectedDateRange } = this.state;
        if (isChecked && selectedDeliveryDate.calendarDateType === 'between') {
            selectedDateRange = [];
            selectedDateRange.push(selectedDeliveryDate.deliveryDate);
        } else if (!isChecked && selectedDeliveryDate.calendarDateType === 'between') {
            const rangeStartDate = CalendarUtility.convertToDateObj(selectedDeliveryDate.rangeStartDate);
            const rangeEndDate = CalendarUtility.convertToDateObj(selectedDeliveryDate.deliveryDate);
            selectedDateRange = CalendarUtility.getDateStringBtn(rangeStartDate, rangeEndDate).map((date) => (
                CalendarUtility.convertDateObjToDateStr(date)
            ));
        }
        if (isChecked && Object.prototype.hasOwnProperty.call(calendarResponse, 'guaranteedCharge')) {
            selectedDeliveryDate.guaranteedChargeToApply = calendarResponse.guaranteedCharge;
            this.setState({ selectedDeliveryDate });
        }

        this.setState({
            selectedDateRange,
            forceExactDay: isChecked,
            holidaySelected: 'Select a holiday',
            selectedDateAnHoliday: false,
        });
    }

    checkWidth = () => {
        const { width } = this.props;
        const widthObj = {
            desktop: false,
            mobile: false,
        };
        switch (width) {
            case 'md':
            case 'lg':
                widthObj.desktop = true;
                break;
            case 'sm':
            case 'xs':
                widthObj.mobile = true;
                break;
            default:
                break;
        }
        return widthObj;
    };

    onHolidaySelected = (selVal) => {
        const { shipHolidayDetails } = this.state;
        this.setState({
            holidaySelected: selVal,
            selectedDateAnHoliday: false,
        });
        if (selVal !== 'Select a holiday') {
            const holidayDetails = shipHolidayDetails[selVal][0];
            let holidayDateStart = '';

            const tempholidayDate = holidayDetails.holidayDate.split(' ')[0];
            const arrholidayDate = tempholidayDate.split('-');
            holidayDateStart = `${arrholidayDate[0]}-${arrholidayDate[1]}-01`;
            this.getDeliveryResponse(holidayDateStart);
            this.updateSelectedHoliday(holidayDetails);
        } else {
            this.updateSelectedHoliday({});
        }
    }

    onSelectedDate = (date) => {
        const selDate = CalendarUtility.convertDateObjToDateStr(date);
        const selDateProps = this.deliveryDate[selDate];

        if (selDateProps) {
            this.setState((prevState) => ({
                ...prevState,
                holidaySelected: selDateProps[0]?.holidayCode?.[0] || 'Select a holiday',
                selectedDateAnHoliday: !!selDateProps[0]?.holidayCode?.[0],
            }), () => {
                const updateSelectedDateDetails = this.getSelectedDateDetails(selDateProps, date, false);
                this.setState({
                    ...updateSelectedDateDetails,
                });
            });
        }
    }

    getShippingType = () => {
        let shippingType = 'Standard';
        const { shopRunnerLoggedIn, isPassportUser, passportSubscriptionStatus } = this.props;
        if (shopRunnerLoggedIn) {
            shippingType = 'ShopRunner';
        }
        if (isPassportUser || passportSubscriptionStatus) {
            shippingType = 'Passport';
        }
        return shippingType;
    }

    getIfHolidayDateSelected = () => {
        const { holidaySelected } = this.state;
        // eslint-disable-next-line no-unneeded-ternary
        return (holidaySelected !== 'Select a holiday' && holidaySelected !== '') ? true : false;
    }

    getSelectedDateDetails = (selDateDetailsProps, dateObj, savedDateHoldiayDate = false, selectedDateType = '') => {
        const { forceExactDay } = this.state;
        const { flags } = this.props;
        const calendarResponse = this.response;
        const isHolidaySelected = this.getIfHolidayDateSelected();
        const selDateProps = selDateDetailsProps[0];
        selDateProps.dateObj = dateObj;
        const { holidayCode, holidayStartDate } = selDateProps;
        let selectedDateRange = [];

        if (flags['is-calendar-date-type-by-enabled'] && selDateProps.calendarDateType === 'by') {
            selectedDateRange.push(selDateProps.deliveryDate);
        } else if (selDateProps.calendarDateType === 'on' || (selectedDateType === 'on' && selDateProps.calendarDateType === 'between') || (forceExactDay === true && selDateProps.calendarDateType === 'between')) {
            selectedDateRange.push(selDateProps.deliveryDate);
        } else if (selDateProps.calendarDateType === 'between') {
            const deliveryDate = CalendarUtility.convertToDateObj(selDateProps.deliveryDate);
            const rangeStartDate = (holidayCode && holidayStartDate && (isHolidaySelected || savedDateHoldiayDate)) ? CalendarUtility.convertToDateObj(holidayStartDate) : CalendarUtility.convertToDateObj(selDateProps.rangeStartDate);
            selectedDateRange = CalendarUtility.getDateStringBtn(rangeStartDate, deliveryDate).map((date) => (
                CalendarUtility.convertDateObjToDateStr(date)
            ));
        }

        if (Object.prototype.hasOwnProperty.call(calendarResponse, 'guaranteedCharge')) {
            selDateProps.guaranteedChargeToApply = calendarResponse.guaranteedCharge;
        }

        const updateforceExactDay = (this.selectedDateType === 'on' && selDateProps.calendarDateType === 'between') ? true : forceExactDay;

        return {
            selectedDateRange,
            selectedDeliveryDate: selDateProps,
            forceExactDay: updateforceExactDay,
        };
    }

    getDeliveryResponse = async (detailsForDate) => {
        const {
            updateShowLoadingMessage, orderItemId, orderItem,
            flagOffShowLoadingMessage, orderId, flags, zipCode,
            auth,
        } = this.props;

        const { errorMessage } = this.state;
        const jwtToken = await auth.getAccessTokenSafely();
        updateShowLoadingMessage();

        // Clear All Errors
        if (errorMessage) {
            this.setState({ errorMessage: '' });
        }

        if (
            flags['which-calendar-variation'] === 'availability'
            && orderItem
            && orderItem.product?.productCode
            && orderItem.product?.brandCode
            && zipCode
        ) {
            // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
            const skuProductCode = orderItem.product.productCode.match(/[^-_]*$/);
            const brandCode = orderItem.product.brandCode;
            const recipientZipCode = zipCode.split('-')[0];
            const locationType = orderItem.deliveryInfo.locationType || 'Residence';

            getDeliveryCalendarByProduct(
                {},
                jwtToken,
                skuProductCode,
                brandCode,
                recipientZipCode,
                locationType,
                detailsForDate,
            ).then((response) => this.handleDeliveryResponse(response, detailsForDate)).catch((err) => {
                flagOffShowLoadingMessage();
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    function: 'getDeliveryCalendarByProduct',
                    message: 'getDeliveryCalendarByProduct -- Error calling Calendar API',
                    jsError: err,
                });

                this.setState({ errorMessage: err.response.data.errorMessage });
            });
        } else if (flags['which-calendar-variation'] === 'cart') {
            const payload = {
                env: {},
                jwtToken,
                cartId: orderId,
                cartItemId: orderItemId,
                startDate: detailsForDate,
            };
            cartServiceClient.displayCalendar(payload)
                .then((response) => this.handleDeliveryResponse(response, detailsForDate)).catch((err) => {
                    flagOffShowLoadingMessage();
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        function: 'displayCalendar',
                        message: 'displayCalendar -- Error calling Calendar API',
                        jsError: err,
                    });

                    this.setState({ errorMessage: err.response.data.errorMessage });
                });
        }
    }

    getLastDateFromCalendarView = (dateCollection) => {
        const year = Object.keys(dateCollection);
        const month = Object.keys(dateCollection[year[year.length - 1]]);
        const weeks = Object.keys(dateCollection[year[year.length - 1]][month[month.length - 1]]);
        const lastCalendarWeekCollection = dateCollection[year[year.length - 1]][month[month.length - 1]][weeks[weeks.length - 1]];
        const lastDateKey = Object.keys(lastCalendarWeekCollection)[Object.keys(lastCalendarWeekCollection).length - 1];
        const lastDate = lastCalendarWeekCollection[lastDateKey];
        return lastDate;
    }

    getHolidayDeliveryDate = (holidayCode, calendarDates) => {
        const [holidayDateDetails] = calendarDates.filter((dateObj) => {
            // Handle Array Type for holidaycode - ["CH", "NW"]
            // And String Type for holidaycode - "CH"
            if (dateObj?.holidayCode && Array.isArray(dateObj.holidayCode) && dateObj.holidayCode.includes(holidayCode)) {
                return dateObj;
            } if (dateObj?.holidayCode === holidayCode) {
                return dateObj;
            }
            return '';
        });
        if (holidayDateDetails && holidayDateDetails.deliveryDate) {
            return holidayDateDetails.deliveryDate;
        }
        return '';
    }

    getButtonStyleForBrandSpecific = (brand, classes) => ({
        selectedBtn: classes.selectedBtn,
        selectedUpChargeBtn: classes.selectedUpChargeBtn,
        upChargeBtn: classes.upChargeBtn,
    })

    getSelectedMonthDetails = (newDate, calendarDateType, deliverySLA) => {
        this.setState({
            selectedDeliveryDate: {
                calendarDateType,
                deliverySLA,
                rangeStartDate: newDate,
                deliveryDate: newDate,
            },
            activeMonth: newDate,
        });
    };

    getSelectedWeekDetails = (newDate, calendarDateType, deliverySLA, weekOfCode) => {
        this.setState({
            selectedDeliveryDate: {
                calendarDateType,
                deliverySLA,
                weekOfCode,
                rangeStartDate: newDate,
                deliveryDate: newDate,
            },
            activeWeek: newDate,
        });
    };

    updateSelectedHoliday = (selHoliday) => {
        this.setState({
            selectedHoliday: selHoliday,
            selectedDateAnHoliday: false,
        });
    }

    getSavedDateHolidayCode = () => {
        const { orderItem } = this.props;

        return orderItem?.deliveryInfo?.holidayCode || '';
    }

    handleDeliveryDateResponse = (response, detailsForDate) => {
        const dataDeliveryCalendar = response.data.response;
        const calendarDates = dataDeliveryCalendar?.calendarDates || [];
        const shipHolidays = dataDeliveryCalendar.shipHolidays || [];
        const guaranteedCharge = dataDeliveryCalendar.guaranteedCharge;

        this.response = dataDeliveryCalendar;
        const { flagOffShowLoadingMessage } = this.props;
        const calendarDatesLength = calendarDates.length;

        if (calendarDatesLength > 0) {
            // Delivery Calendar Dates
            this.deliveryDate = CalendarUtility.getDeliveryDates(calendarDates);
            const collectionOfHolidayByHolidayCode = CalendarUtility.getHolidayDates(shipHolidays);

            const firstDateFrmResp = calendarDates[0].deliveryDate;
            const lastDateFrmResp = calendarDates[calendarDatesLength - 1].deliveryDate;

            // Round Dates
            const roundDateParaStartDate = CalendarUtility.convertToDateObj(firstDateFrmResp);
            const roundDateParaEndDate = CalendarUtility.convertToDateObj(lastDateFrmResp);
            const roundedDates = CalendarUtility.roundDateCalendarStartAndEndDate(roundDateParaStartDate, roundDateParaEndDate);

            // Date Range Selection Start
            let selDateProps = '';
            const { selectedHoliday } = this.state;
            let isSelectedDateAnHoliday = false;

            let selectHolidayCode = 'Select a holiday';
            this.holidayDateCollection = shipHolidays.map((itemHolidayDetails) => itemHolidayDetails.holidayDate.split(' ')[0]);
            const selectedDateHoliday = shipHolidays.filter((itemHolidayDetails) => itemHolidayDetails.holidayDate.split(' ')[0] === this.selectedDate);

            if (this.savedDateHoliday || selectedHoliday?.holidayDate || selectedDateHoliday?.length > 0) {
                isSelectedDateAnHoliday = true;
                selectHolidayCode = selectedHoliday?.holidayCode || selectedDateHoliday?.[0]?.holidayCode || this.savedDateHoliday;
                this.selectedDate = this.getHolidayDeliveryDate(selectHolidayCode, calendarDates);
            }

            selDateProps = this.deliveryDate[this.selectedDate];

            if (selDateProps) {
                const selDateObj = CalendarUtility.convertToDateObj(this.selectedDate);
                const updateSelectedDateDetails = this.getSelectedDateDetails(selDateProps, selDateObj, isSelectedDateAnHoliday, this.selectedDateType);
                this.setState(updateSelectedDateDetails);
            }
            // Date Range Selection End
            const objStartDate = roundedDates.startDate;
            const objEndDate = roundedDates.endDate;
            const calendarViewData = CalendarUtility.getDaysBreakDown(objStartDate, objEndDate);
            const calendarEndDate = this.getLastDateFromCalendarView(calendarViewData);

            this.setState({
                startDate: objStartDate,
                endDate: calendarEndDate.dateObj,
                calendarResponse: dataDeliveryCalendar,
                calendarDisplayData: calendarViewData,
                showLoader: false,
                shipHolidayDetails: collectionOfHolidayByHolidayCode,
                selectedDateAnHoliday: isSelectedDateAnHoliday,
                holidaySelected: selectHolidayCode,
            });

            if (!guaranteedCharge && this.state.forceExactDay) {
                this.setState((prevState) => ({
                    ...prevState,
                    forceExactDay: false,
                }));
            }

            this.selectedDateType = '';
            flagOffShowLoadingMessage();
        } else {
            this.deliveryDate = [];
            const objDetailsFor = CalendarUtility.convertToDateObj(detailsForDate);
            const objStartDate = new Date(objDetailsFor.getFullYear(), objDetailsFor.getMonth(), 1);
            const objEndDate = new Date(objStartDate.getFullYear(), objStartDate.getMonth() + 1, 0);

            const calendarViewData = CalendarUtility.getDaysBreakDown(objStartDate, objEndDate);
            const calendarEndDate = this.getLastDateFromCalendarView(calendarViewData);

            this.setState({
                startDate: objStartDate,
                endDate: calendarEndDate.dateObj,
                calendarResponse: {
                    calendarDates: [],
                    deliveryIndicator: '-',
                    guaranteedCharge: 'null',
                    guaranteedMethod: 'null',
                    shipHolidays: [],
                    holidaySelected: 'Select a holiday',
                },
                calendarDisplayData: calendarViewData,
                showLoader: false,
                shipHolidayDetails: {},
                selectedDateAnHoliday: false,
                forceExactDay: false,
            });

            this.holidayDateCollection = [];
            this.selectedDateType = '';
            flagOffShowLoadingMessage();
        }
    }

    handleDeliveryMonthResponse = (response) => {
        const { flagOffShowLoadingMessage, selectedDate, orderItem } = this.props;
        const dataDeliveryCalendar = response.data.response;
        const { calendarDates } = dataDeliveryCalendar;
        this.response = dataDeliveryCalendar;
        if (calendarDates.length > 0) {
            const monthDatedData = [];
            calendarDates.forEach((mnth) => {
                const fullDate = new Date(mnth.deliveryDate);
                const { calendarDateType, deliverySLA  } = mnth;
                monthDatedData.push({
                    day: fullDate.getDate(),
                    month: fullDate.getMonth(),
                    year: fullDate.getFullYear(),
                    calendarDateType,
                    deliverySLA,
                });
            });
            const isMonthDatedCalendar = dataDeliveryCalendar?.deliveryIndicator === 'MO';
            this.setState({
                isMonthDatedCalendar,
                monthDatedData,
                activeMonth: selectedDate,
                selectedDeliveryDate: {
                    calendarDateType: orderItem?.deliveryInfo?.deliveryDateType,
                    deliverySLA: orderItem?.deliveryInfo?.deliverySLA,
                    rangeStartDate: selectedDate,
                    deliveryDate: selectedDate,
                },
            });

            flagOffShowLoadingMessage();
        }
    }

    handleDeliveryWeekResponse = (response) => {
        const { selectedDate, orderItem, flagOffShowLoadingMessage } = this.props;
        const dataDeliveryCalendar = response.data.response;
        const { calendarDates } = dataDeliveryCalendar;
        this.response = dataDeliveryCalendar;
        if (calendarDates.length > 0) {
            const weekDatedData = [];
            calendarDates.forEach((week) => {
                const fullDate = new Date(week.deliveryDate);
                const { calendarDateType, deliverySLA, weekOfCode } = week;
                weekDatedData.push({
                    month: fullDate.getMonth(),
                    date: fullDate.getDate(),
                    year: fullDate.getFullYear(),
                    calendarDateType,
                    deliverySLA,
                    weekOfCode,
                });
            });
            const isWeekDatedCalendar = dataDeliveryCalendar?.deliveryIndicator === 'WO';
            this.setState({
                isWeekDatedCalendar,
                weekDatedData,
                activeWeek: selectedDate,
                selectedDeliveryDate: {
                    calendarDateType: orderItem?.deliveryInfo?.deliveryDateType,
                    deliverySLA: orderItem?.deliveryInfo?.deliverySLA,
                    rangeStartDate: selectedDate,
                    deliveryDate: selectedDate,
                },
            });
            flagOffShowLoadingMessage();
        }
    }

    initCalendar = () => {
        const { selectedDate, orderItem, flags } = this.props;
        const tempDate = selectedDate.split('-');
        let getResponseFor = `${tempDate[0]}-${CalendarUtility.addLeadingZero(tempDate[1])}-01`;
        if (flags['is-calendar-anchor-by-current-date']) {
            getResponseFor = CalendarUtility.convertDateObjToDateStr(CalendarUtility.getCurrentDate());
        }
        const selectedDeliveryDate = `${tempDate[0]}-${CalendarUtility.addLeadingZero(tempDate[1])}-${CalendarUtility.addLeadingZero(tempDate[2])}`;
        this.selectedDate = selectedDeliveryDate;
        this.savedDateHoliday = this.getSavedDateHolidayCode();
        this.selectedDateType = orderItem?.dateType || '';

        this.getDeliveryResponse(getResponseFor);
    }

    calNextCallBack = () => {
        this.setState({
            showLoader: true,
        });
        let nextDate = '';
        const { endDate } = this.state;
        const lastDateOfTheMonthOfEndDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
        if (lastDateOfTheMonthOfEndDate.getTime() === endDate.getTime()) {
            const objTempDate = new Date(endDate);
            objTempDate.setDate(1);
            // The date is reset to 1 before the month is changed to prevent skipping months.
            // When going from months with 31 days to 30.
            objTempDate.setMonth(objTempDate.getMonth() + 1);
            const objNextMonthStartDate = new Date(objTempDate.getFullYear(), objTempDate.getMonth(), 1);
            nextDate = CalendarUtility.convertDateObjToDateStr(objNextMonthStartDate);
        } else {
            const objTempDate = new Date(endDate);
            objTempDate.setDate(1);
            nextDate = CalendarUtility.convertDateObjToDateStr(objTempDate);
        }
        this.getDeliveryResponse(nextDate);
    }

    callGoBackCallBack = () => {
        this.setState({
            showLoader: true,
        });
        const { endDate } = this.state;
        const firstDateOfLastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        const strPrevMonthStartDate  = CalendarUtility.convertDateObjToDateStr(firstDateOfLastMonth);
        this.getDeliveryResponse(strPrevMonthStartDate);
    }

    calPrevCallBack = () => {
        this.setState({
            showLoader: true,
        });
        const { startDate } = this.state;
        const objTempDate = new Date(startDate);
        objTempDate.setMonth(objTempDate.getMonth() - 1);
        const objPrevMonthStartDate = new Date(objTempDate.getFullYear(), objTempDate.getMonth(), 1);
        const strPrevMonthStartDate = CalendarUtility.convertDateObjToDateStr(objPrevMonthStartDate);
        this.getDeliveryResponse(strPrevMonthStartDate);
    }

    monthlyWeeklyCalendarNotice = () => {
        const { classes } = this.props;
        return (
            <div className={classes.monthlyWeeklyText}>
                <p>
                    <strong>Notice: </strong>Due to varying harvest conditions, a specific arrival date is not available for this item.
                </p>
            </div>
        );
    }

    showSelectedMonthWeek = () => {
        const { classes } = this.props;
        const { activeMonth, activeWeek } = this.state;
        let fullDate;
        if (activeMonth) {
            // regex - replace hypen to slash eg - "2020-10-10" to "2020/10/10"
            fullDate = new Date(activeMonth.replace(/-/g, '/'));
        } else if (activeWeek) {
            // regex - replace hypen to slash eg - "2020-10-10" to "2020/10/10"
            fullDate = new Date(activeWeek.replace(/-/g, '/'));
        }
        const date = fullDate.getDate();
        const month = fullDate.getMonth();
        const year = fullDate.getFullYear();
        const getFullMonth = CalendarUtility.MonthsFull[month];
        const getShortMonth = CalendarUtility.MonthShort[month];
        let ShowArrivalMessage;
        if (activeMonth) {
            ShowArrivalMessage = <p className={classes.monthlyWeeklyText}>Your package will arrive in {getFullMonth} {year}</p>;
        } else if (activeWeek) {
            ShowArrivalMessage = <p className={classes.monthlyWeeklyText}>Your package will arrive in Week of {getShortMonth} {date} {year}</p>;
        }
        return (
            <div>
                {ShowArrivalMessage}
            </div>
        );
    }

    overWriteDateComponent = (day, selectedDates, onSelectedDate, index, rootClasses) => {
        const {
            classes, brand, isPassportUser, passportSubscriptionStatus, shopRunnerLoggedIn,
        } = this.props;
        if (day) {
            const keyDay = `dayIndex${index}_${day.date}`;
            const dateDetails = this.deliveryDate[day.date];
            let upchargeStyle = classes.pricePerDay;
            let isEnabledBtn = false;
            let styleBtn = ''; // disabled button style
            let upCharge = '';
            const isHoliday = (this.holidayDateCollection.indexOf(day.date) >= 0);

            if (dateDetails) {
                isEnabledBtn = true;
                const totalCharges = (parseFloat(dateDetails[0].upcharge || 0, 10)) + (parseFloat(dateDetails[0].surcharge || 0, 10));
                if (totalCharges > 0) {
                    upCharge = `+$${totalCharges.toFixed(2)}`;
                }
            }

            // Free Shipping
            if (!upCharge && (isPassportUser || passportSubscriptionStatus || shopRunnerLoggedIn)) {
                upCharge = 'Free';
            }

            const holidayBtnStyle = (isHoliday) ? classes.holidayBtnStyle : '';
            const brandStyle = this.getButtonStyleForBrandSpecific(brand, classes);
            if (selectedDates.indexOf(day.date) < 0 && upCharge && upCharge !== 'Free') { // charges displayed and date unselected
                styleBtn = `${brandStyle.upChargeBtn} ${holidayBtnStyle}`;
            } else if (selectedDates.indexOf(day.date) >= 0 && upCharge && upCharge !== 'Free') { // charges displayed and date selected
                styleBtn = brandStyle.selectedUpChargeBtn;
                upchargeStyle = classes.pricePerDaySelected;
            } else if (selectedDates.indexOf(day.date) < 0 && upCharge && upCharge === 'Free') { // charges displayed and date unselected
                styleBtn = `${classes.freeDelivery} ${holidayBtnStyle}`;
            } else if (selectedDates.indexOf(day.date) >= 0 && upCharge && upCharge === 'Free') { // charges displayed and date selected
                styleBtn = classes.selectedFreeBtn;
                upchargeStyle = classes.pricePerDaySelected;
            } else if (selectedDates.indexOf(day.date) >= 0) { // date selected
                styleBtn = brandStyle.selectedBtn;
            } else if ((selectedDates.indexOf(day.date) < 0)) { // date unselected
                styleBtn = `${classes.unselectedBtn} ${holidayBtnStyle}`;
            }

            const dayDate = day.dateObj.getDate();

            return (
                <Grid item xs align="center" style={{ padding: '0' }} key={keyDay} className={`${styleBtn} ${(isEnabledBtn ? `button-enabled ${rootClasses?.root}` : `button-disabled ${rootClasses?.disable}`)}`}>
                    <Typography key={index} className={classes.dayOfTheWeek}>
                        {isEnabledBtn && (
                            <Button onClick={() => { onSelectedDate(day.dateObj); }}>
                                <div>{dayDate}{isHoliday && <sup>*</sup>}</div>
                                {upCharge && (
                                    <div className={upchargeStyle}>
                                        <div className={classes.chargeTextStyle}>{upCharge}</div>
                                    </div>
                                )}
                            </Button>
                        )}
                        {!isEnabledBtn
                            && (
                                <Button disabled className={classes.disabledBtn}>
                                    <div>{dayDate}{isHoliday && <sup>*</sup>}</div>
                                </Button>
                            )}
                    </Typography>
                </Grid>
            );
        }

        const keyDay = `dayDisabled${index + Math.random()}`;
        return (
            <Grid item xs align="center" style={{ padding: '0' }} key={keyDay} className={rootClasses?.disable}>
                {/* PAST DATE - SHOW EMPTY BOX */}
                <Typography key={index} className={classes.dayOfTheWeek}>
                    <Button disabled className={classes.disabledBtn}>&nbsp;</Button>
                </Typography>
            </Grid>
        );
    }

    returnApplyDate = () => {
        const { updateDeliveryDate } = this.props;
        const {
            selectedDeliveryDate, forceExactDay, selectedDateAnHoliday, holidaySelected, calendarResponse,
        } = this.state;

        updateDeliveryDate(
            selectedDeliveryDate,
            forceExactDay,
            selectedDateAnHoliday,
            holidaySelected,
            calendarResponse.guaranteedMethod,
        );
    }

    handleCalendarClose = () => {
        const {
            handleAreYouSureCloseCalendar,
        } = this.props;

        const { selectedDeliveryDate, holidaySelected } = this.state;

        let calendarDateChanged = false;
        const curSelectedDate = selectedDeliveryDate?.deliveryDate || '';

        if (curSelectedDate !== '' && this.selectedDate !== curSelectedDate) {
            calendarDateChanged = true;
        } else if ((holidaySelected !== '' && holidaySelected !== 'Select a holiday') && this.savedDateHoliday !== holidaySelected) {
            calendarDateChanged = true;
        }

        handleAreYouSureCloseCalendar(calendarDateChanged);
    }

    render() {
        const {
            selectedDeliveryDate, selectedHoliday, calendarResponse,
            shipHolidayDetails, forceExactDay, selectedDateAnHoliday,
            holidaySelected, isMonthDatedCalendar, isWeekDatedCalendar,
            startDate, endDate, showLoader, selectedDateRange, calendarDisplayData,
            monthDatedData, activeMonth, weekDatedData, activeWeek, errorMessage,
        } = this.state;

        const {
            classes, brand, deliveryTextData, isOpen, flags,
            closeDeliveryCalModel, isPassportUser, passportSubscriptionStatus, shopRunnerLoggedIn,
            areYouSureCloseCalendar, closeAreYouSureMessage,
        } = this.props;
        console.log('states', this.state);
        console.log('this values', {
            deliveryDate: this.deliveryDate,
            selectedDate: this.selectedDate,
            savedDateHoliday: this.savedDateHoliday,
            selectedDateType: this.selectedDateType,
            holidayDateCollection: this.holidayDateCollection,
        });
        const checkWidth = this.checkWidth();
        const shippingType = this.getShippingType();
        const ArrivalDetailsTemplate = (
            <Grid className={classes.gridStyle} item xs={12}>
                <ArrivalDetails
                    isUseCalendarDateTypeByEnabled={flags['is-calendar-date-type-by-enabled']}
                    brand={(brand.code)}
                    arrivalDateDetails={selectedDeliveryDate}
                    selectedHolidayDetails={selectedHoliday}
                    applyDateCallBack={this.returnApplyDate}
                    calendarResponse={calendarResponse}
                    onChangeForceExactDay={this.onChangeForceExactDay}
                    closeDeliveryCalModel={closeDeliveryCalModel}
                    getDeliveryResponseFor={this.getDeliveryResponse}
                    shippingDetails={shipHolidayDetails}
                    forceExactDay={forceExactDay}
                    updateSelectedHoliday={this.updateSelectedHoliday}
                    isPassportUser={isPassportUser}
                    passportSubscriptionStatus={passportSubscriptionStatus}
                    selectedDateAnHoliday={selectedDateAnHoliday}
                    holidaySelected={holidaySelected}
                    onHolidaySelected={this.onHolidaySelected}
                    isMonthDatedCalendar={isMonthDatedCalendar}
                    isWeekDatedCalendar={isWeekDatedCalendar}
                    shopRunnerLoggedIn={shopRunnerLoggedIn}
                    getCancelButton={checkWidth.desktop}
                />
            </Grid>
        );
        return (
            <Dialog
                open={isOpen}
                onClose={this.handleCalendarClose}
                fullScreen
                classes={{
                    root: classes.deliveryCalendarDialogRoot,
                    paper: classes.deliveryCalendarDialogPaper,
                }}
            >
                {areYouSureCloseCalendar && (
                    <CloseCalendarConsent
                        closeModal={closeDeliveryCalModel}
                        saveDate={this.returnApplyDate}
                        closeAreYouSureMessage={closeAreYouSureMessage}
                    />
                )}
                <div>
                    <DeliveryCalendarHeader closeDeliveryCalModel={this.handleCalendarClose} deliveryTextData={deliveryTextData} />
                    {(errorMessage && endDate) && (
                        <Button
                            className={classes.prevButton}
                            onClick={() => {
                                this.callGoBackCallBack();
                            }}
                        >
                            Go Back
                        </Button>
                    )}
                    {(startDate && endDate)
                    && (
                        <Grid className={`${classes.marginTopToFixHeader} ${classes.deliveryCalenderContainer}  marginTopRaised`} container>
                            {!errorMessage && (deliveryTextData.deliveryHeaderCaption !== '')
                                && (
                                    <Grid item xs={12}>
                                        <Typography variant="body2" className={classes.deliveryHeaderCaption}>
                                            {deliveryTextData.deliveryHeaderCaption}
                                        </Typography>
                                    </Grid>
                                )}
                            <Grid className={`${classes.gridStyle} ${classes.gridStylePadding}`} item xs={12} sm={12} md={8}>
                                {showLoader === false
                                && (
                                    <CalendarView
                                        onClickCalNext={this.calNextCallBack}
                                        onClickCalPrev={this.calPrevCallBack}
                                        onSelectedDate={this.onSelectedDate}
                                        overWriteDateComponent={this.overWriteDateComponent}
                                        selectedDates={selectedDateRange}
                                        calendarDisplayData={calendarDisplayData}
                                        getMediumDayFormat={checkWidth.desktop}
                                        getIconPlaceholder={checkWidth.desktop}
                                    />
                                )}
                                {!errorMessage && showLoader === true
                                && <div className={classes.calendarLoader} />}
                                {errorMessage
                                && (
                                    <ErrorMessage
                                        error={errorMessage}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} className={classes.arrivalDetailsContainer}>
                                <Grid container>
                                    {ArrivalDetailsTemplate}
                                    <Grid className={`${classes.gridStyle} ${classes.gridStyleMargin}`} item xs={12}>
                                        {(checkWidth.desktop)
                                            && (
                                                <Typography variant="body2" className={classes.chargeTextStyle}>
                                                    Shipping
                                                </Typography>
                                            )}
                                        <List dense>
                                            <ListItem>
                                                <span className={classes.legendShipAndUpCharge} />
                                                <ListItemText
                                                    className={classes.legendTextStyle}
                                                    secondary={`${shippingType} Shipping + Upcharge - (Weekend / Next-Day Delivery)`}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <span className={classes.legendStandardShipingCharge} />
                                                <ListItemText
                                                    className={classes.legendTextStyle}
                                                    secondary={`${shippingType} Shipping Charge`}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <span className={classes.legendUnavailable} />
                                                <ListItemText
                                                    className={classes.legendTextStyle}
                                                    secondary="Unavailable"
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <span className={classes.legendHoliday}>*</span>
                                                <ListItemText
                                                    className={classes.legendTextStyle}
                                                    secondary="Holiday"
                                                />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    {isMonthDatedCalendar
                && (
                    <Grid className={`${classes.marginTopToFixHeader} marginTopRaised`} container>
                        <Grid className={`${classes.gridStyle} ${classes.gridStylePadding} ${classes.relative}`} item>
                            {showLoader === false && (
                                <>
                                    <MonthDatedCalendarView
                                        monthDatedData={(monthDatedData.length > 0) ? monthDatedData : []}
                                        getSelectedMonthDetails={this.getSelectedMonthDetails}
                                        isMonthActive={activeMonth}
                                    />
                                    {this.showSelectedMonthWeek()}
                                    {this.monthlyWeeklyCalendarNotice()}
                                </>
                            )}
                            {showLoader === true
                                && <div className={classes.calendarLoader} />}
                            { errorMessage
                                && (
                                    <ErrorMessage
                                        error={errorMessage}
                                    />
                                )}
                        </Grid>
                        {ArrivalDetailsTemplate}
                    </Grid>
                )}
                    {isWeekDatedCalendar
                && (
                    <Grid className={`${classes.marginTopToFixHeader} marginTopRaised`} container>
                        <Grid className={`${classes.gridStyle} ${classes.gridStylePadding}`} item>
                            {showLoader === false && (
                                <>
                                    <WeekDatedCalendarView
                                        weekDatedData={(weekDatedData.length > 0) ? weekDatedData : []}
                                        getSelectedWeekDetails={this.getSelectedWeekDetails}
                                        isWeekActive={activeWeek}
                                    />
                                    {this.showSelectedMonthWeek()}
                                    {this.monthlyWeeklyCalendarNotice()}
                                </>
                            )}
                            {showLoader === true
                        && <div className={classes.calendarLoader} />}
                            { errorMessage
                            && (
                                <ErrorMessage
                                    error={errorMessage}
                                />
                            )}
                        </Grid>
                        {ArrivalDetailsTemplate}
                    </Grid>
                )}
                    {(!startDate && !endDate && !errorMessage && !isMonthDatedCalendar && !isWeekDatedCalendar)
                    && (
                        <div className={classes.calendarLoader}>
                            Loading....
                        </div>
                    )}
                    {(!startDate && !endDate && errorMessage)
                    && (
                        <Grid className={classes.marginTopToFixHeader}>
                            <ErrorMessage
                                error={errorMessage}
                            />
                        </Grid>
                    )}
                </div>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({
    flags: commonSelectors.getFlags(state),
    isPassportUser: getIsPassportUserLoggedIn(state),
    brand: commonSelectors.getBrand(state),
    passportSubscriptionStatus: getPassportSubscriptionStatus(state),
    shopRunnerLoggedIn: getShopRunnerToken(state),
    orderId: commonSelectors.getOrderId(state),
});

DeliveryCalendar.propTypes = {
    auth: PropTypes.shape({
        getAccessTokenSafely: PropTypes.func.isRequired,
    }).isRequired,
    brand: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    closeDeliveryCalModel: PropTypes.func.isRequired,
    deliveryTextData: PropTypes.shape({
        deliveryHeaderTitle: PropTypes.string,
        deliveryHeaderCaption: PropTypes.string,
    }),
    flags: PropTypes.object.isRequired,
    flagOffShowLoadingMessage: PropTypes.func.isRequired,
    isPassportUser: PropTypes.bool.isRequired,
    orderItemId: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    orderItem: PropTypes.object,
    passportSubscriptionStatus: PropTypes.bool.isRequired,
    updateDeliveryDate: PropTypes.func.isRequired,
    updateShowLoadingMessage: PropTypes.func.isRequired,
    selectedDate: PropTypes.string.isRequired,
    shopRunnerLoggedIn: PropTypes.string,
    width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired,
    zipCode: PropTypes.string.isRequired,
    handleAreYouSureCloseCalendar: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    areYouSureCloseCalendar: PropTypes.bool.isRequired,
    closeAreYouSureMessage: PropTypes.func.isRequired,
};

DeliveryCalendar.defaultProps = {
    shopRunnerLoggedIn: '',
    deliveryTextData: {
        deliveryHeaderTitle: '',
        deliveryHeaderCaption: '',
    },
    orderItem: {},
};

export default compose(
    connect(mapStateToProps),
    withStyles(styles),
    withRouter,
    withWidth(),
    withAuth,
)(DeliveryCalendar);
